/*FOR CONDITIONAL NEED TO ADD THE NEXT LINES
For validations
validations:[
{
  type: 'required',
  message: 'Campo requerido'
},
{
  type: 'min',
  value: 0,
  message: 'Debe ser mayor a 0'
}
  ]
conditional: { 
  field: 'status',
  values:[6],
  validations: [
    { type: 'required', message: 'Campo requerido' },
  ]
}

*/
const PrincipalFields = [
  {
    name: 'comments_internal',
    inputType: 'textarea',
    colSize: 11,
    label: 'Comentario interno',
    type: 'string',
    validations: [],
  },
  /* {
    name: 'comments',
    inputType: 'textarea',
    colSize: 5,
    label: 'Comentario',
    type: 'string',
    validations: [],
  }, */
  {
    name: 'attachments',
    inputType: 'attachments',
    invisible: true,
  },
]

export const FieldsNew = [
  // ...PrincipalFields,
  {
    name: 'status',
    inputType: 'choosen',
    colSize: 4,
    label: 'Estado',
    type: 'string',
    validations: [
      {
        type: 'required',
        message: 'Campo requerido',
      },
      {
        type: 'typeError',
        message: 'Campo requerido',
      },
    ],
  },
]

export const CancelFields = [
  {
    name: 'status',
    inputType: 'choosen',
    colSize: 4,
    label: 'Estado',
    type: 'string',
    validations: [
      {
        type: 'required',
        message: 'Campo requerido',
      },
      {
        type: 'typeError',
        message: 'Campo requerido',
      },
    ],
  },
  {
    name: 'cancel_reason',
    inputType: 'choosen',
    colSize: 12,
    label: 'Motivo',
    type: 'string',
    validations: [],
  },
  ...PrincipalFields,
]

export const ValidationFields = [
  {
    name: 'status',
    inputType: 'choosen',
    colSize: 4,
    label: 'Estado',
    type: 'string',
    validations: [
      {
        type: 'required',
        message: 'Campo requerido',
      },
      {
        type: 'typeError',
        message: 'Campo requerido',
      },
    ],
  },
]

export const CompletedFields = [
  {
    name: 'status',
    inputType: 'choosen',
    colSize: 4,
    label: 'Estado',
    type: 'string',
    validations: [
      {
        type: 'required',
        message: 'Campo requerido',
      },
      {
        type: 'typeError',
        message: 'Campo requerido',
      },
    ],
  },
  ...PrincipalFields,
]
